import { colors } from "./log-options";
import { CmsConfig } from "cms/config";
import Package from "../../../../package.json";

export const consoleLog = (log, level) => {
    let mlevel;
    if (level === "error") {
        mlevel = addColor(colors.red, `[${log.level}]`);
    } else if (level === "warn") {
        mlevel = addColor(colors.yellow, `[${log.level}]`);
    } else if (level === "info") {
        mlevel = addColor(colors.cyan, `[${log.level}]`);
    } else {
        mlevel = addColor(colors.blue, `[${log.level}]`);
    }
    const mdate = addColor(colors.blackBright,`[${log.dt.toISOString()}]`);
    const mmessage = `${mdate} ${mlevel} ${log.message}`;
    log.location = log.context.url;
    log.message = mmessage;
    console.log(mmessage, { log });
    return log;
};

export const cloudLog = (log, level) => {
    // const mdate = addColor(colors.blackBright,`[${log.dt.toISOString()}]`)
    // let mlevel
    let mmessage;
    if (level === "error") {
        // mlevel = addColor(colors.red, `[${log.level}]`)
        // mmessage = `${mdate} ${mlevel} ${addColor(colors.red,`${log.message}`)}`
        mmessage = `${addColor(colors.red,`${log.message}`)}`;
    } else if (level === "warn") {
        // mlevel = addColor(colors.yellow, `[${log.level}]`)
        // mmessage = `${mdate} ${mlevel} ${addColor(colors.yellow,log.message)}`
        mmessage = `${addColor(colors.yellow,log.message)}`;
    } else if (level === "info") {
        // mlevel = addColor(colors.cyan, `[${log.level}]`)
        // mmessage = `${mdate} ${mlevel} ${log.message}`
        mmessage = `${log.message}`;
    } else {
        // mlevel = addColor(colors.blue, `[${log.level}]`)
        // mmessage = `${mdate} ${mlevel} ${log.message}`
        mmessage = `${log.message}`;
    }
    log.location = log?.context?.url;
    log.message = mmessage;
    // console.log(mmessage)
    return log;
};

export const addColor = (colorCode, message) => {
    const enableWebConsole = CmsConfig.Logging.enableConsole;
    if (!enableWebConsole) {
        const open = `\u001b[${colorCode}m`;
        const close = `\u001b[0m`;
        return `${open}${message}${close}`;
    } else {
        return message;
    }
};

export const stripAnsiCodes = (message) => {
    // eslint-disable-next-line no-control-regex
    return message.replace(/[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-ORZcf-nqry=><]/g, "");
};
export const getFilename = (filepath) => {
    return filepath.split(/(\\|\/)/g).pop();
};

// const date_formatted = (date) => {
//     const dateOptions = {
//         weekday: 'long',
//         day: 'numeric',
//         month: 'long',
//         year: 'numeric',
//         hour12: true,
//         hour: 'numeric',
//         minute: '2-digit',
//         second: '2-digit',
//     };
//     date.toLocaleString('en-US', dateOptions)
//     // date.toISOString()
// }

/**
 * Get version of this module
 * @returns {string}
 */
export const getVersion = () => {
    const version  = Package.version;
    return version;
};

/**
 * Get version of this module
 * @returns {string}
 */
export const getPackageName = () => {
    const name  = Package.name;
    return name;
};
